import CreatorPaymentHistoryPaymentTabComponent from "./CreatorPaymentHistoryPaymentTabComponent";

export default CreatorPaymentHistoryPaymentTabComponent;
